module.exports = __webpack_public_path__ + "img/lotto.e3d3131a.png";